export const GET_ALL_TEAMS = '/agentTeam/getAllTeams';
